<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_user") }}</template>
		</core-layout-headline-and-actions>

		<!-- Apeiron Create User Form -->
		<apeiron-users-create v-if="$store.state.tenantId === 'apeiron_uat'" />

		<!-- Default Create User Form -->
		<j-card
			class="xs-12 bg5 r2 p4"
			v-if="$store.state.tenantId !== 'apeiron_uat'"
		>
			<!-- Email -->
			<core-form-input
				componentName="j-base-input-text"
				name="email"
				v-validate="{ required: true, email: true }"
				:validationErrors="errors"
				:label="$t('email')"
				v-model="form1.email"
			/>

			<!-- Role -->
			<core-form-input
				class="mt6"
				componentName="core-select-role"
				name="role"
				v-validate="'required'"
				:label="$t('select_role')"
				:validationErrors="errors"
				v-model="form2.role"
			/>

			<!-- English First Name -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="firstName"
				v-validate="{ required: true }"
				:validationErrors="errors"
				:label="$t('english_first_name')"
				v-model="form1.englishFirstName"
			/>

			<!-- English Last Name -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="lastName"
				v-validate="{ required: true }"
				:validationErrors="errors"
				:label="$t('english_last_name')"
				v-model="form1.englishLastName"
			/>

			<!-- Chinese First Name -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="chineseFirstName"
				:label="$t('chinese_first_name')"
				v-model="form1.chineseFirstName"
			>
				<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
			</core-form-input>

			<!-- Chinese Last Name -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-text"
				name="chineseLastName"
				:label="$t('chinese_last_name')"
				v-model="form1.chineseLastName"
			>
				<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
			</core-form-input>

			<!-- Button -->
			<div class="flex xs-12 xs-between mt6">
				<j-button
					@click="inviteInternal"
					:isLoading="isLoading"
				>{{ $t("create_user") }}</j-button>
				<j-button
					type="bordered"
					@click="$router.push({ name: 'UsersManagement' })"
				>{{ $t("cancel") }}</j-button>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import crmConfig from "@/config/"
import api from "../api/"

// MOCKED User create for apeiro
import ApeironUsersCreate from "../components/mockedApeiron/ApeironUsersCreate"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		ApeironUsersCreate
	},

	data: () => ({
		isLoading: false,
		form1: {
			englishFirstName: null,
			englishLastName: null,
			chineseFirstName: null,
			chineseLastName: null,
			email: null
		},
		form2: {
			role: null
		}
	}),

	methods: {
		async inviteInternal() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const tenantId = this.$store.state.tenantId
			const clientId = crmConfig.CLIENT_ID

			this.isLoading = true
			const res = await api.inviteInternal({
				clientId,
				inviteInternalInput: { ...this.form1 }
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// When user is created, assign him a role
			const loginId = res.data.inviteInternal.id

			this.isLoading = true
			const res2 = await api.assignRole({
				loginId,
				permissionGroupId: this.form2.role
			})
			this.isLoading = false

			if (res2.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Success
			this.$store.dispatch("addMessage", {
				message: { type: "success", text: this.$t("user_invited") }
			})

			this.$router.push({ name: "UsersManagement" })
		}
	}
}
</script>
